export class SortParameters {
  public active: string;
  public direction: string;
  public convertedActive: string;

  constructor(options: { active: string; direction: string }) {
    this.active = options.active;
    this.direction = options.direction;

    this.convertedActive = this.isActiveToString();
  }

  public isActiveToString(): string {
    const activeToString = this.direction === 'desc' ? `-${this.active}` : this.active;
    return `${activeToString}`;
  }
}
